module.exports = __webpack_public_path__ + "img/step05_b_stand_power_right_rear_leg.77447fb6.png";